import React from 'react';
import { View } from 'react-native';

import { Header } from 'components';
import styles from './Home.style';

export default () => (
  <View style={styles.container}>
    <Header />
  </View>
);
